
export const past2019 = {
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    titleImg: 'https://static001.geekbang.org/resource/image/e6/8b/e61e3444480c82301b4f8b2984c0738b.png',
    mobileTitleImg: 'https://static001.geekbang.org/resource/image/b5/c9/b5e6e9c643f4b6b30dbc0fb76d5118c9.png',
    intro: [
      'FinTechathon 微众银行首届金融科技高校技术大赛立足于金融科技前沿领域，分设人工智能和区块链两个赛道，是一个面向海内外所有高校学子的舞台，致力于推动国内外高校学生探索金融科技前沿领域的技术突破和应用创新。',
      '自2019年6月15日开赛以来，共有178支队伍报名，总计659人参赛，涵盖了国内外众多名牌院校，同时也覆盖了从本科到博士的各个学历层次。经过层层选拔，人工智能与区块链赛道各有十支队伍入围决赛。在长达36个小时的马拉松式编程后，双赛道前三甲队伍终于诞生。8月26日，FinTechathon 微众银行首届金融科技高校技术大赛颁奖典礼在深圳前海万科国际会议中心落下帷幕，为历时两个月零十一天的 FinTechathon 大赛画上圆满的句号。'
    ],
    poster: 'https://static001.geekbang.org/resource/image/51/1b/512df44b4896e63320b80111b2b0661b.jpg',
    video: 'https://media001.geekbang.org/customerTrans/735b007ab30330a3b7781b88c9f22338/78f274f-182cb0724bc-0000-0000-01d-dbacd.mp4'
  },

  ai: {
    title: '人工智能作品',
    subTitle: 'FINTECHATHON',
    height: '306px',
    content: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/03/1f/0371c58a4ae30b19b988c21ebcbeaf1f.jpeg',
        worksname: '404 not found',
        teamName: '第一名',
        desc: '参赛作品：联邦微车险—基于横向联邦学习和 5G 技术的个性化车险定价方案<br />5G 和车联网将我们带入车车互联的时代，未来，每台车都可作为独立的数据中心和计算单元，实现本地建模运算；联邦学习则使得数据不出本地的多方联合建模成为可能。该作品是一款基于联邦学习和 5G 技术的新型车险定价方案。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/da/ec/da8ca4c8e109d3442ebb77baa4ed80ec.png',
        worksname: 'GAI',
        teamName: '第二名',
        desc: '参赛作品：PPNE（Privacy-Preserving Network Embedding）<br />通过隐私保护下的节点对齐、邻居采样和表示学习等步骤，让多个银行的客户关系网络能够协作，在逻辑上能够将多个银行的客户交易网络联合起来，并为交易网络中的用户节点学习一个通用的特征表示。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/4d/03/4d5ae5ea4f7389dee7d506a52dd99103.png',
        worksname: 'F4',
        teamName: '第三名',
        desc: '参赛作品：FATE 数据平台<br />FATE 数据平台（FDP）是一款平台型应用产品，致力于打造具有普适性的数据使用权交易环境，带给用户便捷、安全、稳定获益的交易方式。平台用户既可以支付费用发起联邦学习训练模型，又可以为训练提供数据集获得收益。'
      }
    ]
  },

  blockchain: {
    title: '区块链作品',
    subTitle: 'FINTECHATHON',
    height: '390px',
    content: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/8d/d9/8d0eefe4067b455450810c04c9f646d9.jpeg',
        worksname: '紫荆路 tank 团',
        teamName: '第一名',
        desc: '参赛作品：排污权许可区块链交易平台<br />本作品旨在通过区块链构建排污权许可证交易平台，配合交易纠纷仲裁，黑名单，监督审计等链上机制健全、活化市场。实现企业、政府、公众在环保排污上的三权制衡、多元共治，以辅助排污政策制定，共建污水治理生态循环。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/e6/0e/e601fde8be354d0bc0a6203b69f5900e.png',
        worksname: 'BitHacks',
        teamName: '第二名',
        desc: '参赛作品：基于分布式身份的借贷联合风控平台<br />金融的核心是风控，本项目通过联盟链、分布式身份、代理重加密、隐私计算和联邦学习等多项技术，通过统一的网络身份标识符，在数据共享、验证和计算层面实现借贷行业的互联互通，为各平台提供贷前身份认证(防范虚假申请和身份冒用)、反欺诈(反多头借贷、行业黑名单)、可信数据溯源、AI 风险定价等风控服务。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/2d/2d/2d42159d39540e75a36ae583aa9d9b2d.png',
        worksname: '名夏日大作战',
        teamName: '第三名',
        desc: '参赛作品：基于 FISCO BCOS 的学历证书系统—融信链<br />“融信链”是一个使用 fisco-bcos 联盟链作为底层架构的电子学历证书系统。利用 fisco-bcos 的多方参与共识、数据不可篡改和智能合约自动执行等特性来保证证书数据来源安全可靠性，为学生入职升学和企业招聘人才提供便利，为学生信用评估提供可靠数据，构建更加可信、开放、公平公正和高效的国内教育新生态，为建立诚信社会打下坚实基础。'
      }
    ]
  }
}
